import { IRealty, IRealtyDto } from '../api/types';

export function mapRealtyList(dto: IRealtyDto): IRealty {
  return {
    id: dto.id,
    name: dto.corpus ? `${dto.number} к.${dto.corpus}` : dto.number,
  };
}
